<template lang="pug">
  .Insist
    h1(:class="titleAnimation") 我们坚持
    h2 Our vision、mission、values
    .cards
      .card(v-for="(item, index) in insists" :class="[contentAnimation, `animateDelay-${index}`]")
        img(:src="item.img")
        .title {{ item.title }}
        .subtitle {{ item.subtitle }}
        p.text {{ item.text }}
</template>

<script>
  import img1 from '@/assets/images/launch_240px.png'
  import img2 from '@/assets/images/heart_240px.png'
  import img3 from '@/assets/images/diamond_128px.png'
  import Mixin from '../index.js'
  export default {
    name: "Insist",
    mixins: [Mixin],
    data() {
      return {
        insists: [
          {img: img1, title: '使命', subtitle: '科技进化人类', text: 'Realize human evolution based \non science and technology'},
          {img: img2, title: '愿景', subtitle: '让万物更智慧', text: 'Make everything more intelligent'},
          {img: img3, title: '价值观', subtitle: '直面问题，协同进化，正直向善，追求卓越', text:
              'Face problems directly, evolve collaboratively,\nbe honest and kind, and pursue for excellence'},
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .Insist {
    VStack(center)
    padding 100px 0
    .cards {
      HStack(center, center)
      border 1px solid #e0e0e0
    }
    .card {
      VStack(center)
      width 390px
      padding 40px 0
      background-color white
      &:nth-child(3) {
        .text {
          text-align justify
        }
      }
      &:nth-child(2) {
        border-left 1px solid #e0e0e0
        border-right 1px solid #e0e0e0
        padding-bottom 61px
      }
      .title {
        font-size 28px
        FontSetting("思源黑体")
        font-weight 400
        color #222
      }
      .subtitle {
        font-size 18px
        FontSetting("思源黑体")
        font-weight 400
        color #555
      }
      .text {
        font-size 14px
        FontSetting(Montserrat)
        font-weight 200
        color #999
        text-align center
      }
    }
    @media (max-width ipadProScreenWidth) {
      .cards {
        width 100%
      }
      .card {
        width 33%
        &:last-child {
          min-width 347px
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      .cards {
        VStack(center)
        border 0
        .card {
          padding 20px
          &:nth-child(2) {
            border 0
          }
        }
      }
    }
  }
</style>
